module.exports = __webpack_public_path__ + "img/Not_Implemented.b58b4120.png";